<template>
  <div id="registration">
    <v-card>
      <h2>Obnova hesla</h2>
      <v-form
        ref="form"
        v-model="isFormValid"
        class="pb-4"
        @submit.prevent="onSubmit"
      >
        <v-text-field
          v-model="password"
          :rules="[rules.required, rules.minLength]"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          class="my-1"
          outlined
          dense
          label="Nové heslo"
          @click:append="showPassword = !showPassword"
        />
        <v-text-field
          v-model="confirmPassword"
          :rules="[
            rules.required,
            rules.minLength,
            rules.sameAs(confirmPassword, password)
          ]"
          :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showConfirmPassword ? 'text' : 'password'"
          class="my-1"
          outlined
          dense
          label="Potvrdit heslo"
          @click:append="showConfirmPassword = !showConfirmPassword"
        />
        <v-btn class="registration-btn" type="submit">Přihlásit se</v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      confirmPassword: "",
      isFormValid: true,
      showPassword: false,
      showConfirmPassword: false,
      rules: {
        required: value => !!value || this.$t("validate_required"),
        minLength: value =>
          value.length >= 6 || this.$t("validate_pass_length"),
        sameAs: (value, password) =>
          value === password || this.$t("validate_pass_same")
      }
    };
  },
  methods: {
    async resetPassword() {
      try {
        if (this.$route.query.kod) {
          await this.$http.post("doctors/password-reset", {
            new_password: this.password,
            recovery_code: this.$route.query.kod
          });
          this.$store.commit("setAuthenticated", true);
          this.$router.push({ name: "kalkulator" });
        } else {
          alert("Nevalidní odkaz pro obnovu hesla");
        }
      } catch {
        // eslint-disable-next-line no-console
        console.error("Connection error");
      }
    },
    onSubmit() {
      this.$refs.form.validate();
      if (this.isFormValid) {
        this.resetPassword();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#registration {
  .login-link {
    max-width: 25rem;
    margin: 3rem auto 0 auto;
    text-align: center;
  }

  #login-message {
    padding: 1rem;
    font-size: 0.9rem;
    margin-bottom: 1rem;
    background: rgb(253, 192, 192);
  }

  .v-card {
    padding: 2rem;
    max-width: 25rem;
    margin: auto;
    box-shadow: 0px 0px 18px 0px #d1d1d1;
  }

  .registration-btn {
    width: 100%;
    background: #324c8d;
    color: white;
  }

  h2 {
    padding-bottom: 2rem;
  }
}
</style>
